class ComboBuyButton extends HTMLElement {
  constructor() {
    super();
    // Find the cart container (notification or drawer) if it exists
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    console.log(this.cart);
    // Parse the JSON embedded in the component
    const jsonEl = this.querySelector('script[type="application/json"]');
    if (!jsonEl) {
      console.error('Combo: No JSON data found.');
      return;
    }
    try {
      this.comboVariants = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('Combo: Error parsing JSON data.', error);
      return;
    }

    console.log('this.comboVariants', this.comboVariants);

    if (this.comboVariants) {
      this.renderButton();

      // Attach a click event to the add button
      const addButton = this.querySelector('button.combo-add-to-cart');
      if (addButton) {
        addButton.addEventListener('click', () => {
          this.addComboToCart();
        });
      }
    }
  }

  renderButton() {
    // Render a simple Add Combo button.
    this.innerHTML = `
      <button class="button combo-add-to-cart">Add Combo to Cart</button>
    `;
  }

  addComboToCart() {
    // Build an items array from the metaobject variants
    const items = this.comboVariants.map((variant) => ({
      id: variant.id,
      quantity: 1,
    }));

    // Create a payload object for JSON
    const payload = { items };

    // If the cart exists, add extra fields for section rendering
    if (this.cart) {
      payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('Combo added to cart:', response);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-add-combo',
          cartData: response,
        });
        this.cart.renderContents(response);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
      });
  }
}

customElements.define('combo-buy-button', ComboBuyButton);
